import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import stringify from 'fast-json-stable-stringify';
import { gzipSync } from 'fflate';
export var getEncodedAppContext = function getEncodedAppContext(extension) {
  var _extension$egress = extension.egress,
    egress = _extension$egress === void 0 ? [] : _extension$egress,
    _extension$overrides = extension.overrides,
    overrides = _extension$overrides === void 0 ? {} : _extension$overrides,
    _extension$installati = extension.installationConfig,
    installationConfig = _extension$installati === void 0 ? [] : _extension$installati;
  return gzipAndB64Encode({
    egress: egress,
    overrides: overrides,
    installationConfig: installationConfig,
    hostname: window.location.hostname
  });
};
var gzipAndB64Encode = function gzipAndB64Encode(json) {
  var jsonString = stringify(json); // We use fast-json-stable-stringify to ensure that the JSON is deterministic

  try {
    var zippedData = gzipSync(new TextEncoder().encode(jsonString), {
      level: 9,
      // Max compression,
      mtime: 0 // We set the mtime to 0 to ensure that the output is deterministic
    });
    return btoa(String.fromCharCode.apply(String, _toConsumableArray(zippedData)));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err.message);
  }
  return '';
};